export const ACCOUNT_SERVICE = 'AccountService' as const;
export const APPEALS_SERVICE = 'AppealsService' as const;
export const AUTH_SERVICE = 'AuthService' as const;
export const AV_SERVICE = 'AVService' as const;
export const CMP_SERVICE = 'CMPService' as const;
export const CONTACTS_SERVICE = 'ContactsService' as const;
export const DYNAMIC_UI_SERVICE = 'DynamicUIService' as const;
export const EXPERIMENTS_SERVICE = 'ExperimentsService' as const;
export const EXPLORE_SERVICE = 'ExploreService' as const;
export const FEEDBACK_SERVICE = 'FeedbackService' as const;
export const GIF_SERVICE = 'GifService' as const;
export const INSENDIO_SERVICE = 'InsendioService' as const;
export const MEDIA_SERVICE = 'MediaService' as const;
export const MM_SERVICE = 'MMService' as const;
export const META_SERVICE = 'MetaService' as const;
export const OFFER_SERVICE = 'OfferService' as const;
export const ONBOARDING_SERVICE = 'OnboardingService' as const;
export const PASSPORT_SERVICE = 'PassportService' as const;
export const PAYWALL_SERVICE = 'PaywallService' as const;
export const PROFILE_SERVICE = 'ProfileService' as const;
export const PURCHASE_SERVICE = 'PurchaseService' as const;
export const RECS_SERVICE = 'RecsService' as const;
export const REPORT_SERVICE = 'ReportService' as const;
export const SPOTIFY_SERVICE = 'SpotifyService' as const;
export const STACKS_UTIL_SERVICE = 'StacksUtilService' as const;
export const THEMES_SERVICE = 'ThemesService' as const;
export const TINDER_SELECT_SERVICE = 'TinderSelectService' as const;
export const TINDER_U_SERVICE = 'TinderUService' as const;
export const USER_CONNECTIONS_SERVICE = 'UserConnectionsService' as const;
export const USER_SERVICE = 'UserService' as const;
export const VAULT_SERVICE = 'VaultService' as const;
export const VENDOR_USER_TOKENS_SERVICE = 'VendorUserTokensService' as const;
export const VERIFICATION_SERVICE = 'VerificationService' as const;
